import FormattedMessage from 'I18n/components/FormattedMessage';
import LanguageFilterAlert from '../../components/LanguageFilterAlert/LanguageFilterAlert';
import { useImmutableFilters } from '../../features/filters/filtersQueries';
import { FiltersBar, FiltersCard } from '../../features/filters/components/FiltersCard';
import { AllContentTypesFilter } from '../../features/filters/components/AllContentTypesFilter';
import { LanguageFilter } from '../../features/filters/components/LanguageFilter';
import { DurationFilter } from '../../features/filters/components/DurationFilter';
import { LevelFilter } from '../../features/filters/components/LevelFilter';
import { CertificationsFilter } from '../../features/filters/components/CertificationsFilter';
import { DropdownContentSourceFilter } from '../../features/filters/components/DropdownContentSourceFilter';
import { HasGate } from '../../features/accounts';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PlaylistSearchFilters = () => {
  const {
    filtersLoading
  } = useImmutableFilters();
  return !filtersLoading && /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlock: "300",
      children: /*#__PURE__*/_jsxs(FiltersCard, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myLearning.filterBy"
        }), /*#__PURE__*/_jsx(CertificationsFilter, {
          appearsIn: "results"
        }), /*#__PURE__*/_jsx(LevelFilter, {
          appearsIn: "results"
        }), /*#__PURE__*/_jsx(DurationFilter, {
          appearsIn: "results"
        }), /*#__PURE__*/_jsx(HasGate, {
          gate: "Academy:TrainerContent",
          children: /*#__PURE__*/_jsx(DropdownContentSourceFilter, {
            appearsIn: "results"
          })
        }), /*#__PURE__*/_jsx(AllContentTypesFilter, {
          appearsIn: "results",
          excludeTypes: ['LEARNING_PATH']
        }), /*#__PURE__*/_jsx(LanguageFilter, {
          appearsIn: "results"
        })]
      })
    }), /*#__PURE__*/_jsx(LanguageFilterAlert, {})]
  });
};
export const PlaylistSearchFiltersBar = () => {
  const {
    filtersLoading
  } = useImmutableFilters();
  if (filtersLoading) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(FiltersBar, {
      paddingBlock: "400",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myLearning.filterBy"
      }), /*#__PURE__*/_jsx(CertificationsFilter, {
        appearsIn: "results"
      }), /*#__PURE__*/_jsx(LevelFilter, {
        appearsIn: "results"
      }), /*#__PURE__*/_jsx(DurationFilter, {
        appearsIn: "results"
      }), /*#__PURE__*/_jsx(HasGate, {
        gate: "Academy:TrainerContent",
        children: /*#__PURE__*/_jsx(DropdownContentSourceFilter, {
          appearsIn: "results"
        })
      }), /*#__PURE__*/_jsx(AllContentTypesFilter, {
        appearsIn: "results",
        excludeTypes: ['LEARNING_PATH']
      }), /*#__PURE__*/_jsx(LanguageFilter, {
        appearsIn: "results"
      })]
    }), /*#__PURE__*/_jsx(LanguageFilterAlert, {})]
  });
};
export default PlaylistSearchFilters;